import { FlightSubLOBProps } from "components/flexComponents/WizardFlightPWA/typings";
import * as React from "react";
import { UitkTertiaryButton } from "uitk-react-button";
import { locKeys } from "components/flexComponents/WizardFlightPWA/components/l10n";
import { observer } from "mobx-react";
import { MultiCityFlightLeg } from "components/flexComponents/WizardFlightPWA/components/MultiCityFlightLeg";
import {
  UitkLayoutGrid,
  UitkLayoutGridItem,
  UitkLayoutConditionalGridColumnRow,
  UitkLayoutConditionalGridSpan,
} from "uitk-react-layout-grid";
import { useLocalization } from "@shared-ui/localization-context";
import { LobErrorSummary } from "src/components/shared/LobErrorSummary/LobErrorSummary";
import { Viewport, ViewSmall, ViewMedium } from "@shared-ui/viewport-context";

export const MulticityFlight = observer((props: FlightSubLOBProps) => {
  const [linkDisabled, setLinkDisabled] = React.useState(true);

  /**
   * This hook is reached for rehydratation, here the "add a flight" link gets abled, if JS is disabled then this hook is never executed
   */
  React.useEffect(() => setLinkDisabled(false), []);

  const gridColumns: UitkLayoutConditionalGridColumnRow = { small: 1, medium: 12 };
  const addFlightColSpan: UitkLayoutConditionalGridSpan = { small: 1, medium: 12 };

  const { errorInputRef, isMulticityFormValid, updateInvalidFormsState } = props.lobState;

  if (isMulticityFormValid) {
    updateInvalidFormsState();
  }

  const { formatText } = useLocalization();

  return (
    <UitkLayoutGrid columns={gridColumns} space="three">
      {!isMulticityFormValid && (
        <LobErrorSummary
          locHeadingToken={props.getLocError(false)!}
          locLinkToken={props.getLocError(true)}
          linkClickFocusId="multi-error"
          inputErrorRef={errorInputRef}
          colSpan={gridColumns}
          setInputsRefs={props.setInputsRefs}
        />
      )}
      <MultiCityFlightLeg lobState={props.lobState} routeStore={props.routeStore} setInputsRefs={props.setInputsRefs} />

      <Viewport>
        <ViewSmall>
          <>
            {props.lobState.listOfAdditionalLegs.length <
              props.lobState.config.multiCityFlight.maxNumberOfAdditionalLegs && (
              <UitkLayoutGridItem colSpan={addFlightColSpan}>
                <div>
                  <UitkTertiaryButton
                    icon="add"
                    text={formatText(locKeys.addFlightLabel)}
                    onClick={props.lobState.addALeg}
                    disabled={linkDisabled}
                  />
                </div>
              </UitkLayoutGridItem>
            )}
          </>
        </ViewSmall>

        <ViewMedium>
          <>
            {props.lobState.listOfAdditionalLegs.length <
              props.lobState.config.multiCityFlight.maxNumberOfAdditionalLegs && (
              <UitkLayoutGridItem colSpan={addFlightColSpan} className="uitk-type-right">
                <div>
                  <UitkTertiaryButton
                    icon="add"
                    text={formatText(locKeys.addFlightLabel)}
                    onClick={props.lobState.addALeg}
                    disabled={linkDisabled}
                  />
                </div>
              </UitkLayoutGridItem>
            )}
          </>
        </ViewMedium>
      </Viewport>
    </UitkLayoutGrid>
  );
});
